// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Y6xRHI7m4yHtfl {
  position: relative;
  padding: var(--ds-space-100, 8px);
  padding-left: var(--ds-space-400, 32px);
}
.gEYPBFGENzwChh {
  position: absolute;
  top: 5px;
  left: var(--ds-space-0, 0);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listItem": `Y6xRHI7m4yHtfl`,
	"checkIcon": `gEYPBFGENzwChh`
};
export default ___CSS_LOADER_EXPORT___;
